Device.create = function (node, type) {
    var device = new Device();

    device.id = Utils.getNextDefaultId(node.devices, type.plugin, 1);
    device.label = Utils.getNextDefaultLabel(node.devices, type.label, 1);
    device.__node = node;
    device.__type = type;
    device.plugin = type.path;
    device.actors = [];
    device.sensors = [];
    device.configuration = {};

    for (var n in type.configuration) {
        if (type.configuration[n].defaultValue) {
            device.configuration[type.configuration[n].id] = type.configuration[n].defaultValue;
        }
    }

    return device;
};

Device.bind = function (deviceTypes, node, device) {
    Utils.inheritMethods(device, new Device());

    device.__node = node;

    device.bind(deviceTypes);

    return device;
};

/**
 *
 */
function Device() {
    /**
     *
     */
    Device.prototype.bind = function (deviceTypes) {
        this.class = "Device";
        this.__type = deviceTypes[this.plugin];

        for (var n in this.actors) {
            Actor.bind(this, this.actors[n]);
        }

        for (var n in this.sensors) {
            Sensor.bind(this, this.sensors[n]);
        }
    };

    /**
     *
     */
    Device.prototype.getActorType = function (plugin) {
        for (var n in this.__type.actorTypes) {
            if (this.__type.actorTypes[n].plugin === plugin) {
                return this.__type.actorTypes[n];
            }
        }

        throw "No actor type with Plugin ID " + plugin;
    };

    /**
     *
     */
    Device.prototype.getSensorType = function (plugin) {
        for (var n in this.__type.sensorTypes) {
            if (this.__type.sensorTypes[n].plugin === plugin) {
                return this.__type.sensorTypes[n];
            }
        }

        throw "No sensor type with Plugin ID " + plugin;
    };

    /**
     *
     */
    Device.prototype.getActor = function (id) {
        for (var n in this.actors) {
            if (this.actors[n].id === id) {
                return this.actors[n];
            }
        }

        throw "Cannot find Actor [" + id + "].";
    };

    /**
     *
     */
    Device.prototype.getSensor = function (id) {
        for (var n in this.sensors) {
            if (this.sensors[n].id === id) {
                return this.sensors[n];
            }
        }

        throw "Cannot find Sensor [" + id + "].";
    };

    /**
     *
     */
    Device.prototype.getService = function (id) {
        for (var n in this.__type.services) {
            if (this.__type.services[n].id === id) {
                return this.__type.services[n];
            }
        }

        throw "Cannot find Service [" + id + "].";
    };

    /**
     *
     */
    Device.prototype.getContextObject = function (label) {
        for (var n in this.__type.services) {
            if (this.__type.services[n].label.toLowerCase() === label.toLowerCase()) {

                // TODO Trick, we do not have a Service class

                this.__type.services[n].class = "Service";

                return this.__type.services[n];
            }
        }

        // TODO Add Actors and Sensors

        return null;
    };

    /**
     *
     */
    Device.prototype.isSimulated = function () {
        if (this.simulated) {
            return true;
        }

        console.log(this.__node);

        return this.__node.isSimulated();
    };
}
